// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"72f98323","349":"2e4093cb","554":"ad78b6c1","687":"1cb3ab2f","813":"adfccdb9","963":"8f4b0e57","989":"d5b26e8e"}[chunkId] + ".chunk.js";
};